import PopoverContainer from '@/common/components/popover-container';
import Spacer from '@/common/components/spacer';
import InfoSmall from '@/icons/info-small';
import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';

export interface SavingsLineItemDescriptionWithToolTipProps {
  title: string;
  description: string;
  tooltipDescription: string;
  isTriggerStrong?: boolean;
  isSubLineItem?: boolean;
}

export default function SavingsLineItemDescriptionWithToolTip({
  title,
  description,
  tooltipDescription,
  isTriggerStrong,
  isSubLineItem,
}: SavingsLineItemDescriptionWithToolTipProps) {
  const contents = (
    <div className="flex max-w-[220px] flex-col items-center justify-center p-[16px]">
      <p className="body3-strong text-center">{title}</p>
      <Spacer variant="height8" />
      <p className="body3 text-center">{tooltipDescription}</p>
    </div>
  );

  const trigger = (
    <div className="flex flex-row items-center gap-[4px]">
      <p
        className={cn({
          'body3 text-flexcar-neutral50': isSubLineItem && !isTriggerStrong,
          'body3-strong text-flexcar-neutral50': isSubLineItem && isTriggerStrong,
          'body2': !isSubLineItem && !isTriggerStrong,
          'body2-strong': !isSubLineItem && isTriggerStrong,
        })}
      >
        {description}
        {isSubLineItem ? '' : ':'}
      </p>
      <InfoSmall
        fill={isSubLineItem ? colors.neutral60 : colors.neutral10}
        className={cn({
          '-mt-[2px] h-[20px] w-[20px]': !isSubLineItem,
          'h-[16px] w-[16px]': isSubLineItem,
        })}
      />
    </div>
  );

  return (
    <PopoverContainer
      triggerComponent={trigger}
      contents={contents}
      hasArrow={false}
      contentAlign="center"
      contentSide="top"
    />
  );
}
